import { h } from 'preact';
import Image from 'utils/image';
import clsx from 'clsx';
import CartIcon from 'utils/icon/icon-cart.svg';
import PlusIcon from 'utils/icon/icon-plus.svg';
import { decodeId } from 'utils/helpers';

const ShopTheLookCard = ({
  image,
  title,
  product,
  text,
  btnText,
  btnLink,
  total,
}) => {
  const handleClick = (e) => {
    if (product?.id) {
      e.preventDefault();
      document.dispatchEvent(
        new CustomEvent(
          product.type === 'Outfit' ? 'look-overlay:open' : 'quick-view:open',
          {
            detail:
              product.type === 'Outfit'
                ? {
                    id: decodeId(product.id, 'Product'),
                  }
                : {
                    handle: product.handle,
                  },
          },
        ),
      );
    }
  };

  return (
    <a
      href={btnLink}
      onClick={handleClick}
      className={clsx('relative block lc:rounded-10 lc:overflow-hidden ab-test-rounded-0', {
        'pointer-events-none': !product.id && !btnLink,
      })}
    >
      {!!image && (
        <div className="aspect-[327/446] relative">
          <Image
            {...image}
            srcWidths={{ sm: 350, md: 500 }}
            classes="block absolute  inset-0 w-full h-full object-cover"
          />
        </div>
      )}
      <div
        className={clsx(
          'lc:absolute bottom-0 p-16 lc:md:p-16 ml:text-center left-0 ml:pb-0 ab-test-right-0',
          {
            'ml:absolute ml:left-auto ml:right-0 ml:!p-8':
              !text && !title && product?.id,
          },
        )}
      >
        <div className="lc:text-white shop-the-look-item-title">
          {!!title && (
            <div
              className={clsx('display-3 ml:body-1', {
                'lg:display-4': total > 3,
              })}
              dangerouslySetInnerHTML={{ __html: title }}
            ></div>
          )}
          {!!text && (
            <div
              className="body-2 lc:mt-4 ml:mt-8"
              dangerouslySetInnerHTML={{ __html: text }}
            ></div>
          )}
        </div>
        {!!product.id && (
          <button
            className={clsx('lc:cta-text-icon w-max mt-16 ml:mt-8', {
              'ml:cta-primary': text || title,
              'ml:bg-white ml:flex ml:items-center ml:justify-center ml:w-24 ml:h-24':
                !(text || title),
            })}
          >
            <PlusIcon
              className={clsx('w-16 h-auto lc:hidden', {
                hidden: text || title,
              })}
            />
            <CartIcon className="w-16 h-auto ml:hidden" />
            {product.type === 'O'}
            <div
              className={clsx('ab-test-cta', {
                'ml:hidden': !(text || title),
              })}
            >
              {product?.type === 'Outfit'
                ? window.TMW.Strings.product.shopLook
                : window.TMW.Strings.cart.add}
            </div>
          </button>
        )}
        {!product?.id && btnText && (
          <div className="lc:cta-text-icon w-max max-w-full ml:cta-primary mt-16">
            {btnText}
          </div>
        )}
      </div>
    </a>
  );
};

export default ShopTheLookCard;
